window.create_popup = function(url, title, w, h) {
    // Fixes dual-screen position
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'titlebar=no, scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
};

window.formatMoney = function(amount, currency){
    amount = (typeof amount == 'string') ? parseFloat( amount) : amount;

    // Locale number.
    // We need to change the _ in the locale to a - for it to work in Javascript
    var localeNumber =amount.toLocaleString(window.lang.replace('_', '-'), {
        style: 'currency',
        currency: currency
    });

    // Check if the browser supports the options for 'toLocaleString'
    // Taken from: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString#Checking_for_support_for_locales_and_options_arguments
    if(!(!!(typeof Intl == 'object' && Intl && typeof Intl.NumberFormat == 'function'))){
        // Doesn't support the options array, will return the number formatted in en_US and no currency symbol
        // Let's add the currency code at the beginning manually
        return currency+localeNumber;
    }
    // If yes, the currency symbol will be placed correctly automatically, just return the localeNumber
    return localeNumber;

};

window.formatNumber = function(amount){
    // Locale number.
    // We need to change the _ in the locale to a - for it to work in Javascript
    return amount.toLocaleString(window.lang.replace('_', '-'), {maximumFractionDigits: 2});
};

window.isProduction = function(){
    return window.ciEnv === 'production' || window.ciEnv === 'production_uk';
};

// Force Webpack to load all of ours views but don't evaluate them.
require.context('common_views', true, /\.js$/);
require.context('views', true, /\.js$/);

define([
    "underscore",
    "backbone",
    "bootstrap",
	"amdi18n!nls/form_validation_lang",
    "views/common/header_view",
    "views/common/footer_view",
    "promise-polyfill",
    "backbone.validation"
],
function(_, Backbone, bootstrap, formValidationI18n, HeaderView, FooterView, Promise){
    if (!window.Promise) {
        window.Promise = Promise;
    }
    formValidationI18n.init(window.lang);

    // We'll use Backbone.Validation to handle models' validation
    _.extend(Backbone.Model.prototype, Backbone.Validation.mixin);
    Backbone.Validation.configure({
        labelFormatter: 'label'
    });

    // Translate form validation messages.
	_.extend(Backbone.Validation.messages, formValidationI18n);

    // custom pattern for neteller id, secure id
    _.extend( Backbone.Validation.patterns, {
        netellerIdOrEmail: /^(\d+|)$|^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
        netellerSecureId: /^\d{6}$/,
        alphaDashSpacesCommasDots: /^[a-zA-Z0-9\s\-\_\,\.\u3000]*$/,
        alphaDashSpaces: /^[a-zA-Z0-9\s\-\_]*$/
    });

    new HeaderView();
    new FooterView();

    if(window.fileName){
        var CurrentView;
        try{
            CurrentView = require("views/" + window.fileName + ".js");
        }catch(e){
            try{
                CurrentView = require("common_views/" + window.fileName + ".js");
            }catch(e2){
                // Just continue without a file

            }
        }
        if(CurrentView){
            new CurrentView();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/common/js/apps/main.js
// module id = 0
// module chunks = 0